<!-- src/app/meter/components/meter-analytics/meter-status-chart/meter-status-chart.component.html -->

<div class="chart-card">
    <div class="chart-header">
        <h3 class="chart-title">{{ 'meter.analytics.chart_meter_status' | translate }}</h3>
        <span class="chart-total" *ngIf="total > 0">{{ total }}</span>
    </div>
    <div class="chart-container">
        <canvas baseChart
            *ngIf="data.length > 0"
            type="doughnut"
            [data]="chartData"
            [options]="chartOptions">
        </canvas>
        <div *ngIf="data.length === 0" class="no-data">
            {{ 'meter.analytics.no_data' | translate }}
        </div>
    </div>
</div>
